export var LabelStylePropertiesByVariant = {
    bold: {
        fontWeight: 700,
    },
    regular: {
        fontWeight: 400,
    },
};
//# sourceMappingURL=LabelStylePropertiesByVariant.js.map